import { CookieService } from '../services/CookieService'
class Utils {


    GetPaxesKeys(pax, cap, check) {
        let capitilize = !!cap;
        let checkout = !!check;
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];
            let position = i + 1;

            paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "A" : "a"}dults`] = room.adults;
            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                if (childrenRoom.year > 5) {
                    kids += 1;
                } else {
                    infants += 1;
                }
            }
            paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "K" : "k"}ids`] = childrens;
            paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "A" : "a"}gekids`] = childreJoin.join(",");

        }
        paxesKeys[`${capitilize ? "R" : "r"}ooms`] = rooms;
        paxesKeys[`${capitilize ? "A" : "a"}dults`] = adults;
        paxesKeys[`${capitilize ? "K" : "k"}ids`] = kids;

        if (checkout) {
            paxesKeys[`${capitilize ? "K" : "k"}ids`] = paxesKeys[`${capitilize ? "K" : "k"}ids`] + infants
        } else {
            paxesKeys[`${capitilize ? "I" : "i"}nfants`] = infants;
        }

        paxesKeys[`${capitilize ? "A" : "a"}gekids`] = agekids.join(",");


        return paxesKeys;
    }

    getStringPax(pax) {
        let paxstring = "";

        for (var i = 0; i < pax.length; i++) {
            const px = pax[i];
            paxstring += `a:${px.adults}`;
            paxstring += "-c:";
            for (var c = 0; c < px.children.length; c++) {
                let ch = px.children[c];
                paxstring += `${ch.year},`;
            }
            paxstring += "|"
        }


        return paxstring;
    }

    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    saveCookieQuote(params) {

        try {
            if (params) {
                let cloneParams = this.clone(params);
                delete cloneParams.checkoutHash;

                let paramstext = JSON.stringify(cloneParams);

                CookieService.setCookie("quoteparams", paramstext)

            }
        } catch { }

    }

    htmlCancellation(css, html) {
        return `
            <html>
            <head>
                <style>
                #modal-cancellation { display: none;}
                ${css}
                .modal-body,.modal-header{margin-bottom:15px}.modal-header{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #e9ecef;
                    padding-bottom:15px}.modal-header h5{margin:0}.modal-footer{display:flex;justify-content:flex-end;border-top:1px solid #e9ecef;padding-top:15px;
                        margin-top:15px}.border-success{border:1px solid;border-color:#28a745!important}.modal-content{border-radius:8px}.btn-secondary{background-color:#5a6268;border-color:
                    #545b62;color:#fff}.fade:not(.show) { opacity: unset;}
                </style>
            </head>
            <body>
                ${html}
                <script>    
                document.getElementById("_modal_cancellation").addEventListener("click",function(){document.getElementById("modal-cancellation").style.display="block"}),
                document.getElementsByClassName("btnPrimary")[0].addEventListener("click",function(){document.getElementById("modal-cancellation").style.display="none"}),
                document.getElementsByClassName("close")[0].addEventListener("click",function(){document.getElementById("modal-cancellation").style.display="none"});
                const modal=document.getElementById("modal-cancellation"),modalContent=document.querySelector(".modal-content");
                modal.addEventListener("click",function(e){modalContent.contains(e.target)||(modal.style.display="none")});                           
                <\/script>
            </body>
        </html>
        `
    }

    htmlHotelCollect(css, html) {
        return `
        <html>
            <head>
                <style>
                ${css}
                </style>
            </head>
            <body>
                ${html}
            </body>
        </html>`
    }

    getSiteInformation() {
        const culture = window.__pt.cultureData || {};
        const userLocation = window.__pt.userLocation || {};
        const exchange = window.__pt.exchange || {};
        const site = window.__pt.settings.site || {};
        return {
            Country: culture.country,
            CultureCode: culture.cultureCode,
            CultureExternal: culture.cultureExternal,
            InternalCultureCode: culture.internalCultureCode,
            Language: culture.language,
            SiteCode: culture.siteCode,
            SiteName: culture.siteName,
            UserLocation: userLocation.country,
            UserCountry: userLocation.userCountry,
            CurrencyBase: exchange.base,
            CurrencyDisplay: exchange.currency,
            Channel: site.channel
        }
    }
}

export const util = new Utils();